import type { ScreenerSubField } from "epsm-api-types/models";

export const processNestedSubfields = (
	name: string,
	subFields: ScreenerSubField[],
	newColumns: string[],
) => {
	for (const subField of subFields) {
		const columnName = `${name}.${subField.name}`;
		if (subField.subFields?.length) {
			processNestedSubfields(columnName, subField.subFields, newColumns);
		} else {
			newColumns.push(columnName);
		}
	}
};
